import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw60Handlers = [
  // 特集情報取得 /kymw60/getFeatureThemaList
  http.post(PlessService.SERVICE.KYMW60getFeatureThemaList.url, async ({ request }) => {
    const req = await request;
    return HttpResponse.json(getFeatureThemaListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
];

const getFeatureThemaListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        FeatureCode: 'T1',
        FeatureName: '特集１',
      },
      {
        FeatureCode: 'T2',
        FeatureName: '特集2',
      },
      {
        FeatureCode: 'T3',
        FeatureName: '特集3',
      },
      {
        FeatureCode: 'T4',
        FeatureName: '特集4',
      },
      {
        FeatureCode: 'T5',
        FeatureName: '特集5',
      },
    ],
  },
};


